import React, { useState } from 'react'
import { DropDownMenu } from './actions/dropdown_menu/DropDownMenu'
import { SidebarToogle } from './actions/sidebar_toggle/SidebarToogle'
import { SearchAction } from './actions/search/SearchAction'
import { FullscreenAction } from './actions/fullscreen/FullscreenAction'
import { NotificationsAction } from './actions/notifications/NotificationsAction'
import { UserMenuAction } from './actions/user_menu/UserMenuAction'

export const Header = () => {
    const [activeAction, setActiveAction] = useState('')

    const toggleAction = (actionName) => {
        setActiveAction((current) => (current === actionName ? '' : actionName))
    }

    const closeActions = () => {
        setActiveAction('')
    }

  return (
    <header className="nxl-header">
        <div className="header-wrapper">
            <div className="header-left d-flex align-items-center gap-4">
                <button type="button" className="nxl-head-mobile-toggler border-0 bg-transparent p-0" id="mobile-collapse">
                    <div className="hamburger hamburger--arrowturn">
                        <div className="hamburger-box">
                            <div className="hamburger-inner"></div>
                        </div>
                    </div>
                </button>
                <SidebarToogle />
                <div className="nxl-drp-link nxl-lavel-mega-menu">
                    <div className="nxl-lavel-mega-menu-toggle d-flex d-lg-none">
                        <button type="button" className="border-0 bg-transparent p-0">
                            <i className="feather-arrow-left me-2"></i>
                            <span>Back</span>
                        </button>
                    </div>
                    <DropDownMenu
                        show={activeAction === 'dropdown-menu'}
                        onToggle={() => toggleAction('dropdown-menu')}
                        onClose={closeActions}
                    />
                </div>
            </div>
            <div className="header-right ms-auto">
                <div className="d-flex align-items-center" style={{gap: '10px'}}>
                    <SearchAction
                        show={activeAction === 'search'}
                        onToggle={() => toggleAction('search')}
                        onClose={closeActions}
                    />
                    <FullscreenAction />
                    <NotificationsAction
                        show={activeAction === 'notifications'}
                        onToggle={() => toggleAction('notifications')}
                        onClose={closeActions}
                    />
                    <UserMenuAction
                        show={activeAction === 'user-menu'}
                        onToggle={() => toggleAction('user-menu')}
                        onClose={closeActions}
                    />
                </div>
            </div>
        </div>
    </header>
  )
}
